import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useQueryFolderLabelsHelpers } from '../queries/useQueryFolderLabels.js';
import { useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';
import { withConditionalMutation } from '@fabric-app/queries/utilities';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';

const useMutationRenameColorLabel = () => {
  const { client } = useWoody();
  const { track } = useAnalytics();
  const accessToken = useContextAccessToken();
  const { invalidate, updateCachedFolderLabel } = useQueryFolderLabelsHelpers();
  const mutation = useMutation({
    mutationFn: async ({ folderId, colorLabelId, newTitle }) => {
      return await client.v2({
        endpoint: "/v2/folders/{folderId}/color-labels/{colorLabelId}",
        params: {
          folderId,
          colorLabelId: `${colorLabelId}`
        }
      }, {
        method: "put",
        body: {
          name: newTitle.trim()
        },
        query: {
          accessToken
        }
      });
    },
    onMutate: ({ folderId, colorLabelId, newTitle }) => {
      updateCachedFolderLabel(folderId, colorLabelId, newTitle);
    },
    onError: () => {
      toast({
        content: "Failed to rename column"
      });
    },
    onSettled: (_, e, { folderId }) => {
      invalidate(folderId);
    },
    onSuccess: () => {
      track(AnalyticsEvents.RenameLabel);
    }
  });
  return withConditionalMutation(mutation, {
    ignorePredicate: ({ newTitle }) => {
      return !newTitle.trim();
    }
  });
};

export { useMutationRenameColorLabel };
//# sourceMappingURL=useMutationRenameColorLabel.js.map
